// src/hooks/useUndoRedo.ts

import { useEffect, useRef, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '@/store/store'
import {
  saveState,
  undo,
  redo,
  selectCanUndo,
  selectCanRedo,
} from '@/store/features/undoRedoSlice'

const useUndoRedo = () => {
  const dispatch = useDispatch()
  const gameConfig = useSelector((state: RootState) => state.gameConfig)
  const gameDetails = useSelector((state: RootState) => state.gameDetails)
  const gameCode = useSelector((state: RootState) => state.gameCode.gameCode)

  const canUndo = useSelector(selectCanUndo)
  const canRedo = useSelector(selectCanRedo)

  const isInitialized = useRef(false)
  const prevState = useRef<any>(null)

  useEffect(() => {
    if (gameDetails.gameId) {
      const currentState = { gameCode, gameConfig, gameDetails }

      if (!isInitialized.current) {
        if (gameCode !== '' && Object.keys(gameConfig).length > 0) {
          isInitialized.current = true
          prevState.current = currentState
          dispatch(saveState(currentState))
        }
      } else if (
        JSON.stringify(prevState.current) !== JSON.stringify(currentState)
      ) {
        dispatch(saveState(currentState))
        prevState.current = currentState
      }
    }
  }, [gameCode, gameConfig, gameDetails, dispatch])

  const undoAction = useCallback(() => {
    if (canUndo) {
      dispatch(undo())
    }
  }, [dispatch, canUndo])

  const redoAction = useCallback(() => {
    if (canRedo) {
      dispatch(redo())
    }
  }, [dispatch, canRedo])

  return {
    undo: undoAction,
    redo: redoAction,
    canUndo,
    canRedo,
  }
}

export default useUndoRedo
